var Model = require('../Model');

var ServiceClass = Object.create(Model);

ServiceClass.name = 'ServiceClass';
ServiceClass['@class'] = 'ServiceClass';
ServiceClass.url = 'serviceclass';
ServiceClass.fields = {
  name:{
    type: 'text',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
	parent: {
    default: null,
    hidden: true
	},
  color:{
    type: 'text',
    default: null,
    validators: {
      presence: false,
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
  dashPattern:{
    type: 'text',
    default: null,
    validators: {
      presence: true,
      length: {minimum: 1, maximum: 32, default: ''},
    }
  },
};

module.exports = ServiceClass;
